import React from 'react'

function CareHealth() {
  return (
    <div>
      care Health
    </div>
  )
}

export default CareHealth
